import React, { useMemo } from 'react';
import { StudentMonthlyReport, DailyPerformanceEntry } from '@PikaDoApp/npm-pikado-logic';
// @ts-ignore: TS2459 — we know it's there at runtime
import { AttendanceChart } from '@PikaDoApp/pikado-web-dsm';

interface DailyRecord {
  answersCountInClassThisDay: number;
  day: number;
  date: string;
}

interface StudentAttendanceChartContainerProps {
  studentMonthlyReport?: StudentMonthlyReport;
  selectedMonth: string;
  onMonthChange: (month: string) => void;
  monthOptions: Array<{label: string; value: string}>;
  onDayClick?: (dayData: any) => void;
  interactive?: boolean;
  studentDailyPerformanceList: DailyPerformanceEntry[];
}

export const StudentAttendanceChartContainer: React.FC<StudentAttendanceChartContainerProps> = ({
  studentMonthlyReport,
  selectedMonth,
  onMonthChange,
  monthOptions,
  onDayClick,
  interactive = false,
  studentDailyPerformanceList
}) => {
  /**
   * Transforms studentDailyPerformanceList to DailyRecord[] format
   * Converts from DailyPerformanceEntry to the format expected by AttendanceChart
   */
  const transformToDailyRecords = (
    performanceList: DailyPerformanceEntry[] | undefined
  ): DailyRecord[] => {
    if (!performanceList || performanceList.length === 0) {
      return [];
    }

    return performanceList.map((entry) => ({
      answersCountInClassThisDay: entry.studentDailyAnswersCount || 0,
      day: entry.day,
      date: entry.date || '',
      performanceId: entry.performanceId
    }));
  };

  // Transform the data using useMemo for performance
  const dailyRecords = useMemo(() => {
    return transformToDailyRecords(studentDailyPerformanceList);
  }, [studentDailyPerformanceList]);

  return (
    <AttendanceChart
      studentsDailyRecord={dailyRecords}
      totalAnswersCount={studentMonthlyReport?.attempts || 0}
      totalStudentsEngagedThisMonth={1} // Student report is for one student
      monthOptions={monthOptions}
      selectedMonth={selectedMonth}
      onMonthChange={onMonthChange}
      onDayClick={onDayClick}
      interactive={interactive}
    />
  );
};
